module.exports = __webpack_public_path__ + "img/service-4.4ee7d8ea.png";